module.exports = __webpack_public_path__ + "static/img/logo-bg.c671bd8f.svg";